import Marquee from './marquee';

export default Marquee;
export type * from './types';
